export default __webpack_public_path__ + "static/media/activeIcon (2).952b916a.webp";